module.exports = __webpack_public_path__ + "img/AT0000002669651.5e4dd437.png";